module.exports = __webpack_public_path__ + "img/user-check.d609518f.svg";